import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { makeApi } from '../api/client';
import { StoreFormDialog } from '../components/StoreFormDialog';
import type { StoreInput } from './stores.schema';

export default function StoresRoute() {
  const { getAccessToken } = useAuth();
  const api = makeApi(getAccessToken);
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const stores = useQuery({
    queryKey: ['stores'],
    queryFn: async () => (await api.org.listStores()).data,
  });
  const warehouses = useQuery({
    queryKey: ['warehouses'],
    queryFn: async () => (await api.org.listWarehouses()).data,
  });
  const create = useMutation({
    mutationFn: (d: StoreInput) => api.org.createStore({ body: { name: d.name, address: d.address, gstin: d.gstin, default_warehouse_id: d.default_warehouse_id } }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['stores'] }); setOpen(false); },
  });
  return (
    <section>
      <header className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold text-primary">Stores</h1>
        <button onClick={() => setOpen(true)} className="rounded bg-primary px-4 py-2 text-white">Create store</button>
      </header>
      {stores.data?.items?.length === 0 && <p className="text-ink/60">No stores yet. Create your first store, then generate an activation code for a store node.</p>}
      <ul>{stores.data?.items?.map((s) =>
        <li key={s.id} className="border-b py-2"><Link to={`/stores/${s.id}`} className="text-primary underline">{s.name}</Link> — <span className="text-ink/60">{s.status}</span></li>
      )}</ul>
      <StoreFormDialog open={open} onClose={() => setOpen(false)} onSubmit={(d) => create.mutate(d)} warehouses={warehouses.data?.items ?? []} />
    </section>
  );
}
